import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useState } from 'react';

export function LoginForm({
    className,
    onLogin,
    loginWithGoogle,
    isLoading,
    ...props
}: React.ComponentProps<'div'> & {
    onLogin: (email: string, password: string) => Promise<void>;
    loginWithGoogle: () => void;
    isLoading: boolean;
}) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    return (
        <div className={cn('flex flex-col gap-6', className)} {...props}>
            <Card>
                <CardHeader>
                    <CardTitle>Login to your account</CardTitle>
                    <CardDescription>Enter your email below to login to your account</CardDescription>
                </CardHeader>
                <CardContent>
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            onLogin(email, password);
                        }}
                    >
                        <div className='flex flex-col gap-6'>
                            <div className='grid gap-3'>
                                <Label htmlFor='email'>Email</Label>
                                <Input
                                    id='email'
                                    type='email'
                                    placeholder='m@example.com'
                                    required
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </div>
                            <div className='grid gap-3'>
                                <div className='flex items-center'>
                                    <Label htmlFor='password'>Password</Label>
                                    <a
                                        href='#'
                                        className='ml-auto inline-block text-sm underline-offset-4 hover:underline'
                                    >
                                        Forgot your password?
                                    </a>
                                </div>
                                <Input
                                    id='password'
                                    type='password'
                                    required
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                            </div>
                            <div className='flex flex-col gap-3'>
                                <Button type='submit' className='w-full' loading={isLoading}>
                                    Login
                                </Button>
                                <Button
                                    variant='outline'
                                    className='w-full'
                                    onClick={() => {
                                        loginWithGoogle();
                                    }}
                                >
                                    Login with Google
                                </Button>
                            </div>
                        </div>
                        <div className='mt-4 text-center text-sm'>
                            Don&apos;t have an account?{' '}
                            <a href='/register' className='underline underline-offset-4'>
                                Sign up
                            </a>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
}
